module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.9ee8660.ttf";